import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Pricing = lazy(() => import("@/pages/Pricing"));

export const Route = createFileRoute("/_public/pricing")({
  head: () => pageHead({ path: "/pricing", title: "Amorette — Membership & Pricing", description: "Compare Amorette membership options and what each includes for curated, in-person dining experiences." }),
  component: Pricing,
});
